import '../../../assets/css/NavMenuLink.css'
import $ from 'jquery'
import { useState } from 'react'

function NavMenuLink({ href = '/', children, ...props }) {
	const [isActive, setActive] = useState(false)

	$(document).ready(function () {
		const window_top = $(window).scrollTop()
		const anchor_top =
			$(href).offset().top -
			$(href)
				.css('margin-top')
				.replace(/[a-zа-яё]/gi, '')
		const anchor_bottom = $(href).offset().top + $(href).outerHeight()

		if (window_top >= anchor_top && window_top <= anchor_bottom) {
			setActive(true)
		}

		$(window).scroll(function () {
			const window_top = $(window).scrollTop()
			const anchor_top =
				$(href).offset().top -
				$(href)
					.css('margin-top')
					.replace(/[a-zа-яё]/gi, '')
			const anchor_bottom = $(href).offset().top + $(href).outerHeight()
			if (window_top > anchor_top && window_top < anchor_bottom) {
				setActive(true)
			} else {
				setActive(false)
			}
		})
	})

	function scrollTo(element) {
		const pos =
			$(href).offset().top -
			$(href)
				.css('margin-top')
				.replace(/[a-zа-яё]/gi, '') +
			1
		$('html, body').stop().animate({ scrollTop: pos }, 800)
	}

	return (
		<a
			onClick={() => scrollTo()}
			className={
				isActive
					? 'w-[40px] h-[40px] rounded-full flex items-center justify-center active'
					: 'w-[40px] h-[40px] rounded-full flex items-center justify-center bg-gray-100 dark:bg-dark-100'
			}
			href={href}
		>
			{children}
		</a>
	)
}

export default NavMenuLink
